import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ParametreEntityPondere } from "./../../models/ParametreEntityPondere";
import { FondsPropresService } from "./../../services/fonds-propres.service";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { Component, OnInit, ViewChild } from "@angular/core";

@Component({
  selector: "app-parametre-entity-ponderee",
  templateUrl: "./parametre-entity-ponderee.component.html",
  styleUrls: ["./parametre-entity-ponderee.component.scss"],
})
export class ParametreEntityPondereeComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: false })
  sort: MatSort;
  dataSource: MatTableDataSource<ParametreEntityPondere>;
  isLoadingResults = true;

  displayedColumns = [
    "id",
    "codeRule",
    "code",
    "libelle",
    "codeSegmentPrudentiel",
    "ponderation",
    "actions",
  ];
  data: ParametreEntityPondere[] = [];

  constructor(
    private shared: FondsPropresService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.getParametreEntityPonderees();
  }

  getParametreEntityPonderees() {
    this.shared.getParametreEntityPonderees().subscribe(
      (data) => {
        this.data = data;
      },
      (error) => {
        console.log(error);
        this.isLoadingResults = false;
      },
      () => {
        if (this.data == null) {
          this.data = [];
        }

        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isLoadingResults = false;
      }
    );
  }

  //View row in modal popup

  /*ViewImportPortefeuilleDeatil(row)
  {
    const modalRef = this.modalService.open(ViewItemDetailComponent,
      {
        centered: true, 
        backdropClass: 'light-blue-backdrop',
        backdrop: 'static',
        scrollable: true,
        windowClass: 'my-modal-class'
      });
    modalRef.componentInstance.portefeuilleDetail = row;
    modalRef.componentInstance.importPortefeuilleId = this.importPortefeuilleId;
    
    modalRef.result.then((result) => {
      console.log("result", result);
         // on close
         //this.getImportPortefeuilleDetails(this.importPortefeuilleId);
      }, 
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      });
      
  }
  */
}
